<div class="modal-overlay" *ngIf="visible">
  <div class="modal-box">
    <button class="close-btn" (click)="onCancel()">×</button>
    <div class="icon-circle">
     <i class="bi bi-trash3" style="color: #e74c3c; font-size: 24px;"></i>
    </div>
    <p class="msg">Are you sure want to delete this Country Affiliation?</p>
    <p class="notrec">You will not be able to recover it once it is deleted.</p>
    <div class="modal-actions">
      <button class="cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="confirm-btn" (click)="onConfirm()">Delete</button>
    </div>
  </div>
</div>
